//
// Module for the Account Transaction adjustment's page.
//
rs.module("content/participant/member/disabilityapplication/exams",

    [
        "common/select-helper",
        "common/visibility",
        "controls/components/event-banner"
    ],

    function (selectHelper, visibility, eventBanner) {
        var _executeSelectionChanged;

        function initialize(jsSelectors, disabilityExamsGrid, backendUrl, addDoctorForNewExam) {
            var examsForm = $.js(jsSelectors.examsForm);
            var examAddLink = examsForm.js(jsSelectors.examAddLink);
            var examDetailContainer = examsForm.js(jsSelectors.examDetailContainer);
            var examDueDate = examDetailContainer.js(jsSelectors.examDueDate);
            var appointmentDate = examDetailContainer.js(jsSelectors.appointmentDate);
            var doctorSelect = examDetailContainer.js(jsSelectors.doctorSelect);
            var doctorSelectHelper = selectHelper.getHelper(doctorSelect);
            var updateToken = examDetailContainer.js(jsSelectors.updateToken);
            var disabilityExamKey = examDetailContainer.js(jsSelectors.disabilityExamKey);
            var addDoctorLink = examDetailContainer.js(jsSelectors.addDoctorLink);

            disabilityExamsGrid.selectionChanged(function (values, rows) {
                appointmentDate.clearErrors();

                if (_executeSelectionChanged && values.length > 0) {
                    eventBanner.removeAllMessages();

                    $.getJSON(backendUrl, { disabilityExamKey: values[0] }).done(function (data) {
                        visibility.show(examDetailContainer);

                        examDueDate.val(data.examDueDate ? new Date(data.examDueDate).toISODateString() : null);
                        appointmentDate.val(data.appointmentDate);
                        doctorSelectHelper.setValue(data.physicianKey);
                        updateToken.val(data.updateToken);
                        disabilityExamKey.val(values[0]);
                        addDoctorLink.attr('href', data.addDoctorUrl);
                    });
                }
            });

            examAddLink.click(function () {
                visibility.show(examDetailContainer);
                disabilityExamsGrid.selectedValues = null;

                examDueDate.val(null);
                appointmentDate.val(null);
                doctorSelectHelper.setValue(null);
                updateToken.val(null);
                disabilityExamKey.val(-1);
                addDoctorLink.attr('href', addDoctorForNewExam);
            });

            _executeSelectionChanged = true;
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);